//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  addCallbackForMaybeKeybordFold,
  removeCallbackForMaybeKeybordFold,
} from '../keyboard-fold-detector.js';

export default {
  props: {
    value: String,
    placeholder: {
      type: String,
      default: '',
    },
    editable: {
      type: Boolean,
      default: true,
    },
    blurOnSoftKeyboardClosed: {
      type: Boolean,
      default: true,
    },
  },
  mounted() {
    this.$refs.el.innerText = String(this.value);
  },
  methods: {
    select() {
      this.$refs.el.focus();
      window.getSelection().selectAllChildren(this.$refs.el);
    },
    focus() {
      // Calling .focus() is necessary to trigger the soft keyboard on
      // Android. However, it places the caret at the beginning of the
      // div, so we need to adjust the selection then.
      this.$refs.el.focus();
      window.getSelection().selectAllChildren(this.$refs.el);
      window.getSelection().collapseToEnd();
    },
    blur() {
      this.$refs.el.blur();
    },
    onFocus() {
      if (this.blurOnSoftKeyboardClosed) {
        addCallbackForMaybeKeybordFold(this.blur);
      }
    },
    onBlur() {
      removeCallbackForMaybeKeybordFold(this.blur);
    },
  },
  watch: {
    value(newValue, oldValue) {
      newValue = String(newValue);
      if (this.$refs.el.innerText != newValue) {
        this.$refs.el.innerText = newValue;
      }
    },
  },
  computed: {
    forwardedListeners() {
      // We override the input event with our custom one, so this one should be
      // not forwarded.
      const result = Object.assign({}, this.$listeners);
      delete result.input;
      return result;
    },
  },
};
